import React, { useMemo } from "react";
import Button from "../../../VibehutUI/Button";
import { StoreContext } from "../../../Context/StoreContext";
import { initiateAccessPassPayment } from "../../../services/paymentService";
import Loader from "../../../VibehutUI/Loader";
import { showLoginModal } from "../../../actions/uiModalActions";
export default function WeeklyPassCard({
  roomId,
  amount,
  roomName,
  isModerator,
}) {
  const { state, dispatch } = React.useContext(StoreContext);
  const { accessPass, auth } = state;
  const [loading, setLoading] = React.useState(false);

  const roomPass = useMemo(() => {
    if (accessPass.data) {
      return accessPass.data.find(
        (pass) => pass.kind === "room" && pass.refItem === roomId
      );
    }
    return undefined;
  }, [accessPass.data, roomId]);

  const handleBuy = async () => {
    if (!auth?.user?.token) {
      return showLoginModal(dispatch);
    }

    if (loading) return;

    setLoading(true);
    try {
      await initiateAccessPassPayment(
        auth?.user?.token,
        amount,
        roomId,
        "room",
        `Weekly Pass for "${roomName}" room`
      ).finally(() => {
        setLoading(false);
      });
    } catch {}
  };

  if (accessPass.isFetching) {
    return null;
  }

  if (roomPass || isModerator) {
    return (
      <div className="pt-4 pb-4">
        <div className="md:pr-10 flex flex-col space-y-4 max-w-md">
          <div
            className={`flex justify-between items-center  text-base font-bold pb-2  pt-4`}
          >
            <div className="flex items-center space-x-2 dark:text-frescoWhite text-black">
              <p>Weekly Pass</p>
            </div>
          </div>
        </div>

        <div className="md:pr-10 pt-1 flex flex-col space-y-4 max-w-md">
          <p className="text-sm font-normal  text-darkGray ">
            You have the weekly pass for this room. You can enjoy all the events
            of this room til the pass expires.
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="pt-4 pb-4">
        <div className="md:pr-10 flex flex-col space-y-4 max-w-md">
          <div
            className={`flex justify-between items-center  text-base font-bold pb-2  pt-4`}
          >
            <div className="flex items-center space-x-2 dark:text-frescoWhite text-black">
              <p>Weekly Pass</p>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex justify-center font-normal">
                {loading ? (
                  <Loader size="vibhut-sm" />
                ) : (
                  <Button
                    size="vibhut-sm"
                    variant="vibhut-secondary"
                    onClick={handleBuy}
                    disabled={loading}
                  >
                    {`Buy for $${Number(amount).toFixed(2)}`}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="md:pr-10 pt-1 flex flex-col space-y-4 max-w-md">
          <p className="text-sm font-normal  text-darkGray ">
            Get unlimited access to all paid and free events for an entire week!
          </p>
        </div>
      </div>
    </>
  );
}
